import type React from 'react';

import styles from './styles';

import {
  DefaultInput,
  DescriptionListDefault,
  Divider,
} from '@cobliteam/base-components';

import Button from '@cobliteam/ui/components/Button';

interface InputModuleProps {
  onClose: () => void;
  onSubmit: () => void;
  onInputChange: (text: string) => void;
  inputValue: string;
  descriptionText: string;
  placeholderText: string;
  buttonText: string;
}

const InputModule = ({
  onClose,
  onSubmit,
  onInputChange,
  inputValue,
  descriptionText,
  placeholderText,
  buttonText,
}: InputModuleProps) => {
  const handleTextAreaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const newText = event.target.value;
    onInputChange(newText);
  };

  return (
    <>
      <div className={styles.contentWrapper}>
        <DescriptionListDefault>{descriptionText} </DescriptionListDefault>
        <DefaultInput
          placeholder={placeholderText}
          onChange={handleTextAreaChange}
          type='text'
          value={inputValue}
        />
      </div>
      <Divider />
      <div>
        <div className={styles.buttonSection}>
          <Button variant='text' type='button' onClick={onClose}>
            Cancelar
          </Button>
          <Button
            variant='contained'
            type='button'
            disabled={inputValue === ''}
            onClick={onSubmit}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </>
  );
};

export default InputModule;
